/** Standard in-app page stack. App layout already pads and caps width. */
export const pageLayoutClass = "flex w-full min-w-0 flex-col gap-6";
